export default __webpack_public_path__ + "static/media/NCCameroon.06937476.png";